'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps, CountryData } from 'react-international-phone';
import { PhoneInput, defaultCountries } from 'react-international-phone';
import './phone-input-styles.css';

export const PhoneInputField = forwardRef<
  HTMLInputElement,
  PhoneInputProps & { variant?: 'outlined' | 'default' }
>(function PhoneInputField({ className, variant, ...props }, ref) {
  const [focused, setFocused] = useState(false);
  const phoneInputRef = useRef(ref ?? null);

  const customCountries = defaultCountries.map(country => {
    if (country[1] === 'sk') {
      return ['Slovakia', 'sk', '421', '... ... ...'] as CountryData;
    }
    return country;
  });

  const locale = useLocaleStore(s => s.currentLocale);

  const defaultCountryFromLocale = () => {
    if (locale === 'cs') {
      return 'cz';
    }

    return locale;
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const current = phoneInputRef.current as any;

      if (current && !current.contains(event.target)) {
        setFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [phoneInputRef]);

  return (
    <div ref={phoneInputRef as any} className={cn('h-[52px] w-full', className)}>
      <PhoneInput
        defaultCountry={defaultCountryFromLocale()}
        name="phone"
        countries={customCountries}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputClassName={cn('bg-input', props.inputClassName)}
        inputStyle={{
          height: '48px',
          paddingLeft: '20px',
          width: '100%',
          border: 'none',
          borderEndEndRadius: 0,
          borderStartEndRadius: 0,
          backgroundColor: 'transparent',
        }}
        countrySelectorStyleProps={{
          buttonClassName: 'bg-white',
          buttonStyle: {
            height: '48px',
            border: 'none',
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            paddingLeft: '12px',
            backgroundColor: 'transparent',
          },
        }}
        {...props}
      />
    </div>
  );
});

PhoneInputField.displayName = 'PhoneInputField';
